import { Form, Modal, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import {
  createSupportCourse,
  getSupportCourses,
} from "store/slices/supportCoursesSlice";
import SupportCourseForm from "./support-course-form";

const NewSupportCourseModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();

  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.supportCourses);

  const open = isModalOpen && modalType === "new_support_course";

  const onSubmit = async (values) => {
    try {
      // Créer un FormData pour gérer les fichiers
      const formData = new FormData();

      // Ajouter les champs normaux
      formData?.append("instructorId", values?.instructorId);
      formData?.append("price", JSON?.stringify(values?.price));
      formData?.append("description", values?.description);
      formData?.append("subjectId", values?.subjectId);
      formData?.append("educationLevel", values?.educationLevel);

      // Ajouter les tableaux
      formData?.append("type", JSON?.stringify(values?.type));
      formData?.append("state", JSON?.stringify(values?.state));

      // Ajouter l'image de couverture si elle existe
      if (values?.coverImg?.[0]?.originFileObj) {
        formData?.append("coverImg", values?.coverImg[0]?.originFileObj);
      }

      // Ajouter les ressources si elles existent
      if (values?.supportCourseRes?.length > 0) {
        values?.supportCourseRes?.forEach((file) => {
          if (file?.originFileObj) {
            formData?.append("supportCourseRes", file?.originFileObj);
          }
        });
      }

      console?.log("formData Before api call : ", values);
      await dispatch(createSupportCourse(formData))?.unwrap();
      await dispatch(getSupportCourses())?.unwrap();

      notification?.success({
        message: t("supportCourse.crud.form.success"),
        duration: 3,
      });
      onClose();
    } catch (error) {
      notification?.error({
        message: t("supportCourse.crud.form.error.failed"),
        description: error?.message || t("common.error.generic"),
        duration: 4,
      });
    }
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };

  return (
    <Modal
      title={t("supportCourse.crud.new")}
      open={open}
      onCancel={onClose}
      onOk={() => form?.submit()}
      confirmLoading={loading}
      width={800}
    >
      <SupportCourseForm form={form} onSubmit={onSubmit} />
    </Modal>
  );
};

export default NewSupportCourseModal;
